<ion-content>

  <div class="container">
    <div class="container__content">
      <div class="logo__wrapper">
        <img class="logo" src="./assets/images/logo.svg">
      </div>
      <div class="title">
        Find your favorite location
      </div>
      <div class="subtitle">
        Enter your stores unique code below and get to placing your orders.
      </div>
      <div class="field">
        <div class="field__label">Store's code</div>
        <input [(ngModel)]="vanityLink" placeholder="Example: joescoffee" class="field__input">
        <ion-button (click)="chooseMerchant(vanityLink)" class="submit" color="brand" expand="block">
          Submit
        </ion-button>
        <div class="field__error" *ngIf="hasError">
          Please enter a valid store's code
        </div>
      </div>
      <div class="order-ready">
        <img class="order-ready__image" src="./assets/images/man-with-phone-order-ready.svg"/>
      </div>
    </div>
  </div>
  <div class="spinner-wrapper" *ngIf="isLoading">
    <app-spinner></app-spinner>
  </div>
</ion-content>
